<template>
  <div class="studycard-edit">
    <div class="title">基本信息</div>
    <Form
      class="form"
      ref="form"
      :model="form"
      :rules="formRules"
      label-position="right"
      :label-width="120"
    >
      <FormItem label="学习卡批次名称" prop="name">
        <Input
          v-model="form.name"
          placeholder="请输入学习卡批次名称"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Input>
      </FormItem>
      <FormItem label="学习卡面额" prop="price">
        <Input
          v-model="form.price"
          placeholder="请输入金额"
          style="width:250px;margin-right:15px;"
          :disabled="disable"
          clearable
        ></Input>
      </FormItem>
      <FormItem label="学习卡内容" prop="commodity_id">
        <div>
          <div v-for="(item,index) in courses" :key="index">
            <span>{{item.title}}</span>
            <a
              v-if="!disable"
              @click="courses.splice(index,1)"
              style="margin-left:20px;color:#999;"
            >删除</a>
          </div>
        </div>
        <Button @click="onAdd" v-if="!disable">选择课程</Button>
      </FormItem>
      <FormItem label="有效期" prop="start_at">
        <DatePicker
          type="daterange"
          placeholder="开始日期 — 结束日期"
          style="width: 250px"
          :value="[form.start_at,form.expired_at]"
          :disabled="disable"
          :editable="false"
          @on-change="onDateRange"
        ></DatePicker>
      </FormItem>
      <FormItem label="发放数量" prop="card_number">
        <Input
          v-model="form.card_number"
          placeholder="请输入发放数量，大于等于1的整数"
          style="width:250px;"
          :disabled="disable"
          clearable
        ></Input>
      </FormItem>
      <FormItem>
        <Button
          class="btn-form btn-margin-right"
          type="primary"
          size="large"
          @click="onSave"
          v-if="!cardID"
        >保存并返回</Button>
        <Button
          class="btn-form btn-margin-right"
          type="primary"
          size="large"
          @click="onBack"
          v-else
        >返回</Button>
      </FormItem>
    </Form>
    <Modal v-model="showModal" title="选择课程" @on-ok="onConfirmSelectCourse" width="800">
      <CourseSelect ref="course" :status="1"></CourseSelect>
    </Modal>
  </div>
</template>

<script>
import CourseSelect from '@/components/GridSelect/CourseSelect'
export default {
  name: 'studycard-edit',
  components: {
    CourseSelect
  },
  data() {
    return {
      form: {
        name: '',
        price: '',
        commodity_id: '',
        start_at: '',
        expired_at: '',
        card_number: ''
      },
      courses: [],
      formRules: {
        name: [{ required: true, message: '名称不能为空' }],
        price: [{ required: true, message: '面额不能为空' }],
        commodity_id: [{ required: true, message: '内容不能为空' }],
        start_at: [{ required: true, message: '有效期不能为空' }],
        card_number: [{ required: true, message: '发放数量不能为空' }]
      },
      cardID: this.$route.query.id,
      showModal: false,
      disable: false,
    }
  },
  created() {
    if (this.cardID) {
      this.requestDetail()
      this.disable = true
    }
  },
  methods: {
    onAdd() {
      this.showModal = true
    },
    onSave() {
      const ids = []
      this.courses.forEach(i => {
        ids.push(i.id)
      })
      this.form.commodity_id = ids.join()
      this.$refs.form.validate(valid => {
        if (!valid) return
        if (this.cardID) {
          this.onBack()
        } else {
          this.$http.post('/api/studyCard/', this.form).then(() => {
            this.$Message.success('新增成功')
            this.onBack()
          })
        }
      })
    },
    onBack() {
      this.$router.back()
    },
    onDateRange(range) {
      this.form.start_at = range[0]
      this.form.expired_at = range[1]
    },
    onConfirmSelectCourse() {
      const list = this.$refs.course.getSelectList()
      this.courses = []
      list.forEach(i => {
        this.courses.push({ id: i.id, title: i.title })
      })
    },
    requestDetail() {
      this.$http.get('/api/studyCard/' + this.cardID).then(data => {
        this.form = data
        this.form.start_at = this.$pub.timestampToTime(data.start_at)
        this.form.expired_at = this.$pub.timestampToTime(data.expired_at)
        this.form.price = this.$pub.calcPrice(data.price)
        this.courses = data.courses
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.studycard-edit {
  .form {
    width: 500px;
  }
  .btn-form {
    width: 100px;
  }
}
</style>
